export default __webpack_public_path__ + "static/media/house_gold.d87fa53e.png";